export default __webpack_public_path__ + "static/media/placeholder.01dbb47e.gif";